<div
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
>
  <label class="form-label" [for]="fieldAttribute.id">
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
  </label>
  <input
    autocomplete="off"
    [class.is-invalid]="isFieldInvalid()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    ngbDatepicker
    #d="ngbDatepicker"
    [id]="fieldAttribute.id"
    [attr.data-test-id]="fieldAttribute.elementDataTestId"
    placeholder="{{ fieldAttribute.backendAttribute.placeholder | translate }}"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [(ngModel)]="date"
    [disabled]="fieldAttribute.disabled"
    (click)="d.toggle()"
    (dateSelect)="onDateChanged()"
    (blur)="setAsTouched()"
    (input)="handleInputChange($event)"
  />
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
